import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CompanyInterestDialogComponent } from '../company-interest-dialog/company-interest-dialog.component';
import { ConfirmationDialogComponent } from '../confitmation-dialog/confirmation-dialog.component';
import { InformationDialogComponent } from './information-dialog.component';

@NgModule({
  declarations: [InformationDialogComponent, ConfirmationDialogComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule, CompanyInterestDialogComponent],
  exports: [InformationDialogComponent, ConfirmationDialogComponent, CompanyInterestDialogComponent]
})
export class InformationDialogModule { }

